// Side-effect module: registers the `landingV2` namespace (all 14 languages)
// into i18next. Imported by LandingV2 so the copy ships with its lazy chunk.
// Idempotent and ordering-safe, same as registerNewLandingI18n.
import i18n from "../i18n";
import landingV2 from "./landingV2";

for (const [code, data] of Object.entries(landingV2)) {
  i18n.addResourceBundle(code, "translation", { landingV2: data }, true, true);
}
